import React from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import toast, { Toaster } from "react-hot-toast";

const Signup = () => {
    const navigate = useNavigate();
    const validationSchema = Yup.object({
        username: Yup.string().required(),
        email: Yup.string().required(),
        password: Yup.string().min(4, 'Password must be at least 4 characters long').required('Password is required'),
    });
    const handleSignup = async (values, { setSubmitting }) => {
        try {
            const response = await fetch(`http://13.229.184.79:5000/signup/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: values.username,
                    email: values.email,
                    password: values.password,
                }),
            });

            if (response.ok) {
                toast.success("Account created successfully! Redirecting to login");
                setTimeout(() => {
                    navigate("/login");
                }, 1000);

            } else {
                toast.dismiss();
                toast.error("Email already exists!");
            }
        } catch (error) {
            console.error("Signup error:", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <div className='flex flex-row justify-center items-center h-screen p-20 xs:p-5'>
                <div className='flex flex-col justify-center max-w-[500px]'>
                    <div className='flex justify-center'>
                        <img src='/images/loginlogo.png' alt='logo' />
                    </div>
                    <div className='border border-gray-200 rounded-3xl p-6 mt-6'>
                        <div className='flex flex-col items-center my-5'>
                            <p className='text-3xl text-gray-600 font-medium xs:text-center xs:text-xl'>Create an account</p>
                            <p className='text-sm text-gray-500 font-normal text-center xs:text-xs'>Lorem ipsum dolor sit amet, consectetur<br></br> adipiscing elit. Morbi lobortis maximus</p>
                        </div>
                        <Formik
                            initialValues={{ username: '', email: '', password: '', }}
                            validationSchema={validationSchema}
                            onSubmit={handleSignup}
                        >
                            {() => (
                                <Form>
                                    <div>
                                        <div>
                                            <div className=' flex flex-col'>
                                                <label className='text-sm text-gray-500 font-normal'>User Name</label>
                                            </div>
                                            <Field type="text" name="username" className="border-2 border-gray-100 p-2 rounded-xl mt-1 w-full" />
                                            <ErrorMessage name="username" component="div" style={{ color: 'red' }} />
                                        </div>
                                        <div className='mt-5'>
                                            <div className=' flex flex-col'>
                                                <label className='text-sm text-gray-500 font-normal'>Email</label>
                                            </div>
                                            <Field type="email" name="email" className="border-2 border-gray-100 p-2 rounded-xl mt-1 w-full" />
                                            <ErrorMessage name="email" component="div" style={{ color: 'red' }} />
                                        </div>
                                        <div className='mt-5'>
                                            <div className=' flex flex-col'>
                                                <label className='text-sm text-gray-500 font-normal'>Password</label>
                                            </div>
                                            <Field type="password" name="password" className="border-2 border-gray-100 p-2 rounded-xl mt-1 w-full" />
                                            <ErrorMessage name="password" component="div" style={{ color: 'red' }} />
                                        </div>
                                        <div>
                                            <ul className='flex flex-row justify-start gap-20 px-6 mt-2 xs:gap-5 xs:px-3'>
                                                <li className='text-xs text-gray-400 font-normal list-disc'>Use 8 or more characters</li>
                                                <li className='text-xs text-gray-400 font-normal list-disc'>Use upper and lower case letters (e.g. Aa)</li>
                                            </ul>
                                            <ul className='flex flex-row justify-start gap-20 px-6 mt-2 xs:gap-5 xs:px-3'>
                                                <li className='text-xs text-gray-400 font-normal list-disc'>Use a number (e.g. 1234)</li>
                                                <li className='text-xs text-gray-400 font-normal list-disc'>Use a symbol (e.g. !@#$) (e.g. Aa)</li>
                                            </ul>
                                        </div>

                                        <div>
                                            <button type="submit" className="p-4 w-full mt-6 text-white bg-green rounded-full">Sign Up</button>
                                        </div>
                                        <div className=''>
                                            <p className='text-sm text-gray-700 mt-4'>By creating an account, you agree to the <span className='underline cursor-pointer underline-offset-2 text-green'>Terms of use</span> and <span className='underline cursor-pointer underline-offset-2 text-green'>Privacy Policy</span>. </p>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                    <div className='mt-5 flex justify-center'>
                        <Link to="/login" className='text-sm text-gray-600 font-normal'>Already have an account? <span className='text-sm text-green font-semibold underline underline-offset-2'>Log in</span></Link>
                    </div>
                </div>
            </div>
            <Toaster />
        </div>
    )
}

export default Signup